import { render } from "./DashboardNpsTrendsModal.vue?vue&type=template&id=545f24ee"
import script from "./DashboardNpsTrendsModal.vue?vue&type=script&lang=js"
export * from "./DashboardNpsTrendsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__